export const ProjectSort = {
  AtoZ: "AtoZ",
  CreatedDate: "CreatedDate",
};
